module.exports = __webpack_public_path__ + "img/logo-icon.537ff121.png";